var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gift_pack_card_inner" }, [
    _c(
      "div",
      {
        class: ["card-type", "card-type" + _vm.value.config.card_type],
        style: { backgroundImage: "url(" + _vm.value.config.imageurl + ")" },
      },
      [
        ["1", "2", "3"].includes(_vm.value.config.card_type)
          ? _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(" 演示卡（含自选礼包） "),
              ]),
              _c("div", { staticClass: "card_no" }, [
                _vm._v(" 6640 2840 3421 9302 "),
              ]),
              _c("div", { staticClass: "money" }, [_vm._v("200.00点")]),
              _c(
                "div",
                {
                  class: [
                    "time",
                    _vm.value.config.is_show_expiration_date === "0" && "hide",
                  ],
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.value.config.card_type === "1" ? "有效期：" : ""
                      ) +
                      "2022.03.22 ～ 2023.03 "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm.value.config.card_type === "4"
          ? _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "title" }, [_vm._v("五一慰问福利卡")]),
              _c(
                "div",
                {
                  class: [
                    "time",
                    _vm.value.config.is_show_expiration_date === "0" && "hide",
                  ],
                },
                [_vm._v(" 2022.03.22 ～ 2023.03.22 ")]
              ),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm.value.config.card_type === "5"
          ? _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "card_no" }, [
                _vm._v("6640 2840 3421 9302"),
              ]),
              _c("div", { staticClass: "title" }, [
                _vm._v(" 优联五一慰问福利卡 "),
              ]),
              _c(
                "div",
                {
                  class: [
                    "time",
                    _vm.value.config.is_show_expiration_date === "0" && "hide",
                  ],
                },
                [
                  _c("div", { staticClass: "duigou" }),
                  _vm._v(" 2022.03.22 ～ 2023.03 "),
                ]
              ),
              _c("div", { staticClass: "money" }, [_vm._v("200.00点")]),
            ])
          : _vm._e(),
        ["6", "8"].includes(_vm.value.config.card_type)
          ? _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(" 福利演示卡（含自选礼包） "),
              ]),
              _c(
                "div",
                {
                  class: [
                    "time",
                    _vm.value.config.is_show_expiration_date === "0" && "hide",
                  ],
                },
                [_vm._v(" 2022.03.22 ～ 2023.03 ")]
              ),
              _vm._m(1),
            ])
          : _vm._e(),
        _vm.value.config.card_type === "7"
          ? _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "left" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(" 福利演示卡（含自选礼包） "),
                ]),
                _c("div", { staticClass: "card_no" }, [
                  _vm._v("6640 2840 3421 9302"),
                ]),
                _c(
                  "div",
                  {
                    class: [
                      "time",
                      _vm.value.config.is_show_expiration_date === "0" &&
                        "hide",
                    ],
                  },
                  [_vm._v(" 2022.03.22 ～ 2023.03 ")]
                ),
              ]),
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "money" }, [_vm._v("200.00点")]),
                _c("div", { staticClass: "con-text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.value.config.exchange_content.slice(0, 4)) +
                      " "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        ["1", "2", "3", "5"].includes(_vm.value.config.card_type)
          ? _c("div", { staticClass: "text" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.value.config.exchange_content.slice(0, 4)) +
                  " "
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "money" }, [_vm._v("200.00点")]),
      _c("div", { staticClass: "card_no" }, [_vm._v(" 6640 2840 3421 9302 ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "money" }, [_vm._v("200.00点")]),
      _c("div", { staticClass: "card_no" }, [_vm._v("6640 2840 3421 9302")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }